import React from "react";
import { loginStatusOptions } from "../AuthProvider/AuthProvider";
import styles from "./LoginScreen.module.scss";
import Loading from "../Loading/Loading";
import koneLogo from "../../assets/kone-logo-white.svg";
import loginIcon from "../../assets/enter.svg";

export interface LoginProps {
  loginStatus: loginStatusOptions;
  onLoginClick: () => void;
}

const LoginScreen: React.FC<LoginProps> = (props: LoginProps) => {
  const { loginStatus, onLoginClick } = props;
  const loginPromptClasses =
    loginStatus === "Prompt" ? [styles.loginPrompt, styles.fadeIn] : [styles.loginPrompt];
  return (
    <div className={styles.loginWrapper}>
      <div className={loginPromptClasses.join(" ")}>
        <div className={styles.loginTitle}>
          <img src={koneLogo} width={50} alt="KoneLog" />
          <span>FaultViewer</span>
        </div>

        {loginStatus === "Prompt" ? (
          <div className={styles.loginButton} onClick={() => onLoginClick()}>
            <span>Login with AAD </span>
            <img src={loginIcon} alt="Login Button" />
          </div>
        ) : (
          <Loading text={loginStatus} />
        )}
      </div>
    </div>
  );
};

export default LoginScreen;
